import { createApp } from 'vue'
import App from './App.vue'
import { formatStoreLabel, groupStoresByCity } from './utils/storeOptions'

const app = createApp(App)
app.config.globalProperties.$formatStoreLabel = formatStoreLabel
app.config.globalProperties.$groupStoresByCity = groupStoresByCity
app.mount('#app')
